import { Licitacao } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';

export class OrgaoAdesaoAudesp extends BaseResourceModel {

  constructor(
    public id?: number,
    public numero_ata?: string,
    public numero_licitacao?: string,
    public data_ata?: Date,
    public data_autorizacao?: Date,
    public nome_detentor?: string,
    public validade_ata?: string,
    public licitacao?: Licitacao,
  ) {
    super();
  }

  static converteJson(json: any): OrgaoAdesaoAudesp {
    return Object.assign(new OrgaoAdesaoAudesp(), json);
  }
}
